<template>
  <v-stepper v-model="e6" vertical>
    <v-stepper-step :complete="e6 > 1" step="1"> General</v-stepper-step>
    <v-stepper-content step="1">
      <v-card color="grey lighten-4" class="mb-12">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  v-model="name"
                  :rules="textRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="language"
                  :items="getLanguages()"
                  :cache-items="false"
                  label="Language"
                  required
                  mandatory
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  :items="audioCollectionOptions"
                  item-text="jsonData.audioCollection.name"
                  v-model="selectedAudioCollection"
                  label="Audio collection"
                  return-object
                />
              </v-col>
            </v-row>

            <v-row
              v-if="
                selectedAudioCollection !== null &&
                selectedAudioCollection.id !== null
              "
            >
              <v-col cols="12" sm="6">
                <v-select
                  :items="audioProfiles"
                  item-text="name"
                  v-model="selectedAudioProfile"
                  label="Default audio profile"
                  return-object
                />
              </v-col>
            </v-row>

            <v-select
              :items="getExecutionMode()"
              v-model="executionMode"
              label="Exectution mode"
              class="col-2"
            ></v-select>

            <p>Target scoring template</p>
            <v-autocomplete
              v-model="targetScoringTemplate[0]"
              :items="getTargetScoringTemplates()"
              item-text="targetScoringDefinition.name"
              item-value="targetScoringDefinition.id"
              :cache-items="false"
              rounded
              solo
            ></v-autocomplete>

            <v-subheader>Sums</v-subheader>
            <div class="col-2">
              <v-text-field
                label="Decimal count"
                v-model.number="numberOfDecimals"
                type="number"
              ></v-text-field>
              <v-checkbox
                v-model="innerHitCount"
                label="Count inner hits"
              ></v-checkbox>
            </div>

            <v-subheader>Event series</v-subheader>
            <div class="col-2">
              <v-checkbox
                class="pa-0 ma-0"
                v-model="enablePreApprove"
                label="Enable pre approve"
              />
            </div>
          </v-container>
        </v-card-text>
      </v-card>

      <v-btn text @click="e6 = 2"> Next </v-btn>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 2" step="2"> Series </v-stepper-step>

    <v-stepper-content step="2">
      <series-edit v-bind:series="series"></series-edit>
      <p></p>
      <v-btn text @click="e6 = 1"> Back </v-btn>
      <v-btn text @click="addshootingprogramtemplate()"> Finish </v-btn>
      <div class="col">
        <ul style="color: red; margin: 10px" v-if="this.error == true">
          <li v-for="(error, index) in errorList" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import {
  ADD_OR_UPDATE_SHOOTING_PROGRAM_TEMPLATE,
  GET_AUDIO_COLLECTION_FULL_QUERY,
} from "../../graphql/shootingProgramQueries.js";
import { GET_TARGET_SCORING_DEFINITION_QUERY } from "../../graphql/targetScoringDefinitionQueries.js";
import * as helpers from "./shootingProgramHelpers.js";
import SeriesEdit from "./Series.js";

export default {
  name: "AddShootingProgram",
  apollo: {
    $client: "shootingProgramClient",
    getAudioCollections: {
      query: GET_AUDIO_COLLECTION_FULL_QUERY,
      loadingKey: "loading",
    },
  },
  components: {
    "series-edit": SeriesEdit,
  },
  created() {
    this.populateScoringDefinitions();
  },
  methods: {
    getChoosenTargetDefinitionList() {
      if (this.targetScoringTemplate.length != 0) {
        return [
          {
            id:
              this.targetScoringTemplate[0].length != 0
                ? this.targetScoringTemplate[0]
                : "",
          },
        ];
      } else {
        return [];
      }
    },

    async populateScoringDefinitions() {
      const DEFQUERY = await this.$apollo
        .query({
          query: GET_TARGET_SCORING_DEFINITION_QUERY,
          client: "targetScoringDefinitionClient",
          variables: {
            id: "",
          },
        })
        .then((response) => {
          return response.data.getTargetScoringDefinition;
        })
        .catch((error) => {
          throw error;
        });

      this.scoringDefinitions = DEFQUERY;
    },

    getExecutionMode() {
      return helpers.getExecutionMode();
    },

    getTargetScoringTemplates() {
      return this.scoringDefinitions;
    },
    getLanguages() {
      return helpers.getLanguages();
    },
    getLanguageAbbreviation(targetLanguage) {
      return helpers.getLanguageAbbreviation(targetLanguage);
    },
    addSerie(serie) {
      this.series.push(serie);
    },

    setTemplateError(typeOfError, message) {
      this.error = true;

      // Opening the affected tabs
      switch (typeOfError) {
        case "Time":
          // this.tab = 0;
          // this.$refs.SeriesPanel[0].setTimeErrorTab();
          break;
        case "Database":
          //...
          break;
        default:
      }

      this.errorList.push(message);
    },

    async addshootingprogramtemplate() {
      //validate base-inputs before adding them to Database
      this.error = false;
      this.errorList = [];
      if (this.name.length == 0)
        this.setTemplateError("Text", "Please fill out the title");
      if (this.language == null)
        this.setTemplateError("Text", "Please choose a language");

      if (this.error) {
        return;
      }

      let calloutConfig = null;
      if (
        this.selectedAudioCollection !== null &&
        this.selectedAudioCollection.id !== null
      ) {
        let audioProfileId = this.selectedAudioProfile
          ? this.selectedAudioProfile.id
          : null;
        if (audioProfileId === null) {
          audioProfileId =
            this.audioProfiles.length > 0 ? this.audioProfiles[0].id : null;
        }
        calloutConfig = {
          audioCollectionId: this.selectedAudioCollection?.id,
          defaultAudioProfileId: audioProfileId,
        };
      }

      const shootingProgramTemplateInput = {
        name: {
          value: this.name,
        },
        defaultProfileName: { value: "" },
        defaultValues: {
          language: this.getLanguageAbbreviation(this.language),
          profileName: {
            value: "",
          },
        },
        executionMode: this.executionMode.toUpperCase(),
        preApprove: this.enablePreApprove,
        profiles: [],
        series: [],
        sumSequences: [],
        sums: [],
        calloutConfig: calloutConfig,
        enableTeamShooting: false,
      };

      // @todo Temporaily removed since it did not work ;)
      // const targetScoringDefinitions = [];
      // if (this.series.length > 0) {
      //   const targetScoringDefinition = await this.$apollo
      //     .query({
      //       query: SEARCH_TARGET_SCORING_DEFINITION_QUERY,
      //       client: "targetScoringDefinitionClient",
      //       variables: {
      //         text: this.targetScoringTemplate,
      //         limit: 1,
      //       },
      //     })
      //     .then((response) => {
      //       return response.data.searchTargetScoringDefinition[0]
      //         .targetScoringDefinition.id; // Query returns an array
      //     })
      //     .catch((error) => {
      //       throw error;
      //     });
      //   targetScoringDefinitions.push(targetScoringDefinition);
      // }

      //Make targetDefinitionsList contain objects instead of primitive values
      // for (let k = 0; k < this.series.length; k++) {
      //   for (let l = 0; l < this.series[k].targetScoringDefinition.length; l++) {
      //     templateStorage.series[l].targetScoringDefinition[l] = {
      //       id: templateStorage.series[l].targetScoringDefinition[l],
      //     };
      //   }
      // }
      // this.targetScoringTemplate[0] = {
      //   id: this.targetScoringTemplate[0],
      // };

      let sumTotal = {
        id: uuidv4(),
        innerHitCount: this.innerHitCount,
        name: {
          defaultValue: {
            value: "Total",
            languages: [],
          },
          profileValues: [],
        },
        numberOfDecimals: this.numberOfDecimals,
        scoreType: "SCORE_POINTS",
        series: [],
        type: "TOTAL",
      };

      this.series.forEach((s) => {
        const serie = {
          id: s.id,
          type: s.type,
          marking: [
            {
              type: "OPEN",
              client: "E_MONITOR",
            },
            {
              type: "OPEN",
              client: "E_SPECTATOR",
            },
          ],
          name: s.name,
          shots: { count: s.shotCount },
          targetScoringDefinition: this.getChoosenTargetDefinitionList(),
          procedures: [],
          eventTemplates: [],
        };

        if (s.timeMode === "NEW") {
          serie.procedures = s.procedures;

          const prep = {
            id: uuidv4(),
            start: "AUTO",
            time: {
              from: {
                defaultValue: {
                  value: s.preparationTime,
                },
              },
              mode: "PREPARATION_TIME",
            },
          };

          const countdown = {
            id: uuidv4(),
            start: "AUTO",
            time: {
              from: {
                defaultValue: {
                  value: s.countdownTime,
                },
              },
              mode: "COUNTDOWN_TIME",
            },
          };

          const scoring = {
            id: uuidv4(),
            start: "AUTO",
            time: {
              from: {
                defaultValue: {
                  value: s.scoringTime,
                },
              },
              mode: "SCORING_TIME",
            },
          };

          if (s.preparationTime != undefined)
            if (s.preparationTime.length != 0)
              if (!helpers.validateTimeInput(s.preparationTime)) {
                this.setTemplateError(
                  "Time",
                  "Invalid input in series: The preparation time input is not written in the correct format. Please use the following format: 'HH:MM:SS'"
                );
              }
          if (s.countdownTime != undefined)
            if (s.countdownTime.length != 0)
              if (!helpers.validateTimeInput(s.countdownTime)) {
                this.setTemplateError(
                  "Time",
                  "Invalid input in series: The countdown time input is not written in the correct format. Please use the following format: 'HH:MM:SS'"
                );
              }

          if (s.scoringTime != undefined)
            if (s.scoringTime.length != 0)
              if (!helpers.validateTimeInput(s.scoringTime)) {
                this.setTemplateError(
                  "Time",
                  "Invalid input in series: The scoring time input is not written in the correct format. Please use the following format: 'HH:MM:SS'"
                );
              }

          if (this.error) {
            return;
          }

          if (!serie.procedures[0].type) {
            serie.procedures[0].type = "SHOOTING_STAGE";
          }

          if (s.preparationTime != undefined)
            if (s.preparationTime.length != 0)
              serie.procedures[0].procedureSteps.push(prep);

          if (s.countdownTime != undefined)
            if (s.countdownTime.length != 0)
              serie.procedures[0].procedureSteps.push(countdown);

          if (s.scoringTime != undefined)
            if (s.scoringTime.length != 0)
              serie.procedures[0].procedureSteps.push(scoring);
        }

        if (s.type != "SIGHTING") {
          let sum = {
            id: uuidv4(),
            innerHitCount: this.innerHitCount,
            name: {
              defaultValue: {
                value: s.name.defaultValue.value,
                languages: [],
              },
              profileValues: [],
            },
            numberOfDecimals: this.numberOfDecimals,
            scoreType: "SCORE_POINTS",
            series: [
              {
                id: s.id,
                shots: null,
              },
            ],
            type: "SERIES_TOTAL",
          };
          sumTotal.series.push({
            id: s.id,
            shots: null,
          });
          shootingProgramTemplateInput.sums.push(sum);
        }
        shootingProgramTemplateInput.series.push(serie);
      });

      if (shootingProgramTemplateInput.series.length != 0) {
        shootingProgramTemplateInput.sums.push(sumTotal);

        let sumSequenceTotal = {
          id: uuidv4(),
          name: {
            defaultValue: {
              value: "Sums",
              languages: [],
            },
            profileValues: [],
          },
          sumIds: [],
        };

        for (let sum of shootingProgramTemplateInput.sums) {
          sumSequenceTotal.sumIds.push(sum.id);
        }

        shootingProgramTemplateInput.sumSequences.push(sumSequenceTotal);
      }

      if (this.error) {
        return;
      }

      await this.$apollo
        .mutate({
          mutation: ADD_OR_UPDATE_SHOOTING_PROGRAM_TEMPLATE,
          variables: {
            shootingProgramTemplate: shootingProgramTemplateInput,
          },
        })
        .catch((err) => {
          this.setTemplateError(
            "Database",
            "Something went wrong with the database connection."
          );
          throw err;
        });

      this.$router.go(-1);
    },
    fromTimeToIsoTime(time) {
      let minutes = "";
      let seconds = "";
      if (!time) {
        time = "00:00";
      }
      const splitTime = time.split(":");
      if (splitTime[0] !== "00") {
        minutes = Number(splitTime[0]) + "M";
      }
      if (splitTime[1] !== "00") {
        seconds = Number(splitTime[1]) + "S";
      }
      const isoTime =
        minutes !== "" || seconds !== "" ? "PT" + minutes + seconds : ""; // Return ISO time only if minutes and/or seconds is set
      return isoTime;
    },
    onAddSeries() {
      this.series.push({
        id: uuidv4(),
        name: {
          defaultValue: {
            value: "New series",
          },
          profileValues: [],
        },
        type: "SIGHTING",

        marking: [
          {
            type: "OPEN",
            client: "E_MONITOR",
          },
          {
            type: "OPEN",
            client: "E_SPECTATOR",
          },
        ],
        shots: 0,
        procedures: [
          {
            id: uuidv4(),
            executionCount: 1,
            procedureSteps: [],
          },
        ],
        eventTemplates: [],
      });
    },
    onDeleteSeries(id) {
      this.series = this.series.filter((serie) => serie.id !== id);
    },
  },
  computed: {
    audioCollectionOptions() {
      return [
        {
          id: null,
          jsonData: { audioCollection: { name: "No collection" } },
        },
      ].concat(this.getAudioCollections);
    },
    audioTemplates() {
      if (this.selectedAudioCollection === null) return [];

      const audioCollection =
        this.selectedAudioCollection.jsonData.audioCollection;
      let audioProfile = this.selectedAudioProfile;
      if (audioProfile === null) {
        audioProfile = audioCollection.audioProfiles[0]
          ? audioCollection.audioProfiles[0]
          : null;
      }

      return audioCollection.audioTemplates.filter((template) =>
        audioProfile.sounds.some(
          (sound) => sound.audioTemplateId === template.id
        )
      );
    },
    audioProfiles() {
      const audioProfile =
        this.selectedAudioCollection.jsonData.audioCollection.audioProfiles;
      return audioProfile ? audioProfile : [];
    },
  },
  data() {
    return {
      dialog: false,
      e6: 1,
      selectedAudioCollection: {
        id: null,
        jsonData: { audioCollection: { name: "No collection" } },
      },
      selectedAudioProfile: null,
      executionMode: "Normal",
      series: [],
      name: "",
      numberOfDecimals: 0,
      innerHitCount: true,
      enablePreApprove: false,
      language: null,
      subGroupItems: ["General", "Time", "Event templates"],
      subTab: null,
      targetScoringTemplate: [],
      scoringDefinitions: [],
      textRules: [(v) => v.length > 0 || "Textfield must not be empty"],
      errorList: [],
      error: false,
    };
  },
};
</script>
